import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
// import {
//     mainStyles,//Estílos genéricos
//     theme//Téma con colores de DS
//     //CustomDynamicButton,//Botón de material ui customizable
// } from '../styles/Main.js'//Se importan los estilos genéricos
import { Typography ,useTheme
} from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import DeleteIcon from '@mui/icons-material/Delete';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
// import GroupsIcon from '@mui/icons-material/Groups';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import PersonAdd from '@mui/icons-material/PersonAdd';
import PhotoCameraOutlined from '@mui/icons-material/PhotoCameraOutlined';
import Group from '@mui/icons-material/Group';
import Description from '@mui/icons-material/Description';
import { ReactComponent as IneIcon } from '../assets/icons/icINE.svg'


import { ReactComponent as DocImage } from '../assets/copy_doc.svg'
import { useTranslation } from 'react-i18next';

// import { CustomControls } from './CustomControls'

export function ListElement(props) {
    const theme = useTheme()
    const location = useLocation()
    const [statusColor, setStatusColor] = React.useState('#ffffff')
    const localStyles = {} //mainStyles.bodyStyles()
    const { t } = useTranslation();

    React.useEffect(() => {
        // console.log("props.................----------evet: ", props)
        if (props.statusColor != undefined) {
            if (props.statusColor == 1) {
                setStatusColor('#28a745')
            } else if (props.statusColor == 2) {
                setStatusColor('red')
            } else if (props.statusColor == 3) {
                setStatusColor('#FFC200') // en aprobación
            } else if (props.statusColor == 4) {
                setStatusColor(theme.palette.primary.main) // color tema
            }
        } else {
            setStatusColor('#ffffff')
        }
    }, [props.statusColor])

    return (
        <div
            key={props.keyProps}
            className={localStyles.listElementStyle}>
            {console.log("props.text----: ", props)}
            <div
                className={props.newItem ? localStyles.greySquare : localStyles.redSquare}
                key={`div_${props.keyProps}`}>
                {props.text.includes('visita') || props.text.includes('Visita')
                    ? <LocationOnIcon style={{ color: theme.palette.primary.color, }} /> :
                    props.text == "INE / IFE*"
                    ? <IneIcon width={20} /> :
                    props.text === 'INE / IFE*'
                        ? <PhotoCameraOutlined style={{ color: theme.palette.primary.color, }} /> :
                        props.text == "Comprobante de domicilio*"
                            ? <PhotoCameraOutlined style={{ color: theme.palette.primary.color, }} /> :
                            props.text === 'Pasaporte*'
                                ? <PhotoCameraOutlined style={{ color: theme.palette.primary.color, }} /> :
                                // props.text === 'Cobro realizado'
                                //     ? <CustomControls type='Image' src="ic_cobro_sin_exito.png" /> :
                                //     props.icon?.includes('IC_SUB_')
                                //         ? <CustomControls type='Image' src={`${props.icon}.svg`} /> :
                                //         props.icon === 'ICONO_02'
                                //             ? <CustomControls type='Image' src='ICONO_02.svg' /> :
                                            props.capture == "Document Upload, Camera"
                                                ? <ReceiptIcon style={{ color: theme.palette.primary.color, }} /> :
                                                props.capture == "Camera"
                                                    ? <PhotoCameraIcon style={{ color: theme.palette.primary.color, }} /> :
                                                    props.capture == "Document Upload"
                                                        ? <AttachFileIcon style={{ color: theme.palette.primary.color, }} /> :
                                                        props.text.includes('Personal') || props.text === 'Presidente'
                                                            ? <AccountBoxIcon style={{ color: theme.palette.primary.color, }} /> :
                                                            props.text === 'Cobranza'
                                                                ? <AttachMoneyIcon style={{ color: theme.palette.primary.color, }} /> :
                                                                props.text === 'Biométricos'
                                                                    ? <AccessibilityNewIcon style={{ color: theme.palette.primary.color, }} /> :
                                                                    props.text.includes('Grupal')
                                                                        ? <Group style={{ color: theme.palette.primary.color }} /> : /// <CustomControls type='Image' src='groupIcon.svg' /> :
                                                                        props.text === 'Tesorero'
                                                                            ? <MonetizationOnIcon style={{ color: theme.palette.primary.color, }} /> :
                                                                            props.text === 'Secretario'
                                                                                ? <PermPhoneMsgIcon style={{ color: theme.palette.primary.color, }} /> :
                                                                                props.text === 'Socio'
                                                                                    ? <PersonIcon style={{ color: theme.palette.primary.color, }} /> :
                                                                                    props.text === 'Nuevo cliente'
                                                                                        ? <PersonAdd style={{ color: theme.palette.primary.color, }} /> :
                                                                                        props.text === 'Soy cliente'
                                                                                            ? <PersonIcon style={{ color: theme.palette.primary.color, }} /> :
                                                                                            // props.icon === 'ICONO_01'
                                                                                            //     ? <CustomControls type='Image' src='ICONO_01.svg' /> :
                                                                                                props.newItem
                                                                                                    ? <AddIcon style={{ color: theme.palette.primary.color, }} /> :
                                                                                                    <Description style={{ color: theme.palette.primary.color, }} />  // <DocImage key={`docimage_${props.keyProps}`} />
                }
            </div>
            <div className={localStyles.elementDetails}>
                <Typography
                    variant="subtitle2"
                    display="block"
                // className={localStyles.listText}
                >
                    {props.text}
                </Typography>

                {props.isRejected
                    ? <Typography
                        variant="caption"
                        display="block"
                        style={{ color: "#F20000" }}
                        className={localStyles.listText} >
                        {t("document_rejected")}
                    </Typography>
                    : (props.isRejected != undefined) ? <Typography
                        variant="caption"
                        display="block"
                        style={{ color: "#28a745" }}
                        className={localStyles.listText} >
                        {t("read_authorized_text")}
                    </Typography> : ''
                }

                {/* {props.description &&
                    <Typography
                        variant="subtitle2"
                        gutterBottom
                        className={localStyles.description}
                    >
                        {props.description}
                    </Typography>

                } */}
                {props.status &&
                    <Typography
                        variant="subtitle2"
                        gutterBottom
                        style={{ color: statusColor }}
                        className={localStyles.listText}>
                        {props.delete && <DeleteIcon
                            key={`delete_${props.keyProps}`}
                            className={localStyles.deleteIcon} />}
                        {props.status}
                    </Typography>

                }

            </div>
            {!props.noArrow && <ArrowForwardIosIcon
                key={`arrow_${props.keyProps}`}
                className={localStyles.arrowIcon} />}
        </div>
    )
}